import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DevRoleSwitcherAuthService {
	private readonly AUTH_STORAGE_KEY = 'dev_role_switcher_authenticated';
	private authSubject = new BehaviorSubject<boolean>(false);
	public auth$: Observable<boolean> = this.authSubject.asObservable();

	constructor() {
		// Load initial state from sessionStorage
		this.checkAuthState();
	}

	/**
	 * Check authentication state from sessionStorage
	 */
	checkAuthState(): boolean {
		try {
			const authState = sessionStorage.getItem(this.AUTH_STORAGE_KEY);
			const isAuthenticated = authState === 'true';
			this.authSubject.next(isAuthenticated);
			return isAuthenticated;
		} catch (e) {
			this.authSubject.next(false);
			return false;
		}
	}

	/**
	 * Set authentication state
	 */
	setAuthenticated(authenticated: boolean): void {
		try {
			if (authenticated) {
				sessionStorage.setItem(this.AUTH_STORAGE_KEY, 'true');
			} else {
				sessionStorage.removeItem(this.AUTH_STORAGE_KEY);
			}
			this.authSubject.next(authenticated);
		} catch (e) {
			// Silently fail - sessionStorage may not be available
		}
	}

	/**
	 * Get current authentication state
	 */
	isAuthenticated(): boolean {
		return this.authSubject.value;
	}
}

